import React from 'react';
import { Rectangle } from 'recharts';
const SquareDot = _ref => {
  let {
    cx,
    cy,
    color
  } = _ref;
  const size = 8;
  return /*#__PURE__*/React.createElement(Rectangle, {
    x: cx - size / 2,
    y: cy - size / 2,
    width: size,
    height: size,
    fill: color
  });
};
export default SquareDot;